import { GameState, GameStatus, EndingType, StateManager, Event, GameConfig, SpecialEffect, SpecialEnding, SpecialEffectType, DelayedEvent, EventCondition, ConditionType, EndingSentiment } from './types';

/**
 * 预定义特殊结局
 */
const SPECIAL_ENDINGS: SpecialEnding[] = [
  {
    title: "忘带文件的惨剧",
    description: "你到达公司后才发现，忘带的重要文件是今天会议的关键材料。会议开始后，你只能尴尬地道歉，并承诺尽快补上。老板的脸色越来越黑...",
    requiredEffects: [SpecialEffectType.FORGOT_DOCUMENTS],
    priority: 3,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "咖啡渍的烦恼",
    description: "你全身沾满咖啡渍到达了公司。同事们投来异样的目光，偏偏今天还有重要客户来访。你只能躲在工位后面，尽量不被人看见。",
    requiredEffects: [SpecialEffectType.SPILLED_COFFEE],
    priority: 1,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "泥泞足迹",
    description: "你的鞋子上全是泥土，走在公司光亮的地板上留下了明显的脚印。清洁工阿姨看你的眼神仿佛要杀人。今天的工作氛围很微妙...",
    requiredEffects: [SpecialEffectType.MUDDY_SHOES],
    priority: 1,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "湿漉漉的一天",
    description: "被雨淋湿的你像只落汤鸡一样坐在工位上，头发还在滴水。空调的冷风让你不停打喷嚏，这一天的工作效率几乎为零。",
    requiredEffects: [SpecialEffectType.RAIN_SOAKED],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "完美状态",
    description: "你今天心情极好，精力充沛地到达公司。整个上午的工作效率出奇地高，甚至提前完成了本周的所有任务。老板对你刮目相看！",
    requiredEffects: [SpecialEffectType.GREAT_MOOD, SpecialEffectType.SUPER_ENERGY],
    priority: 4,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "糟糕透顶",
    description: "既疲惫又心情糟糕的你勉强熬到下班时间。今天的工作几乎没有任何进展，可能明天要加班补上了...",
    requiredEffects: [SpecialEffectType.BAD_MOOD, SpecialEffectType.TIRED],
    priority: 3,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "幸运之星",
    description: "今天的你简直走运到家！刚到公司就发现老板心情特别好，还宣布给部门所有人发放额外奖金！真是完美的一天！",
    requiredEffects: [SpecialEffectType.LUCKY_DAY],
    priority: 5,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "霉运连连",
    description: "这绝对是你职业生涯中最糟糕的一天。刚到工位电脑就蓝屏了，接着打翻了咖啡，然后误删了重要文件。老板最后把你叫进了办公室...",
    requiredEffects: [SpecialEffectType.BAD_LUCK_DAY],
    priority: 5,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "星际CEO",
    description: "你运用外星装置联系上了它的制造者。在他们的'建议'下，你轻松收购了你所在的公司，并宣布将其业务转向星际旅游。你的前老板现在是你的司机。地球，只是起点。",
    requiredEffects: [SpecialEffectType.ALIEN_TECHNOLOGY],
    priority: 7,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "不可言说的晋升",
    description: "那件外星装置在你到达公司时突然发出了低语，只有你能听见。按照指示操作后，第二天你发现自己坐在了CEO的办公室，而没人记得前任CEO是谁，仿佛他从未存在过。",
    requiredEffects: [SpecialEffectType.ALIEN_TECHNOLOGY],
    priority: 7,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "秘密员工",
    description: "你正准备向同事展示外星装置时，老板正好路过。装置突然启动，投射出老板正在浏览购物网站摸鱼的全息图像，但只有你和他看到了这短暂的一幕。老板脸色煞白，立刻把你拉到一边，尴尬地将你评为'本月最佳员工'，并强烈暗示你需要保守这个'小误会'。工资涨了，但这感觉更像是封口费...",
    requiredEffects: [SpecialEffectType.ALIEN_TECHNOLOGY],
    priority: 7,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "紧急控场",
    description: "你拿出外星装置想向同事们炫耀，它突然投射出老板摸鱼的图像！就在同事们要看清时，老板眼疾手快地冲过来关掉了设备（或者假装是普通投影仪故障），然后迅速将你评为'本月最佳员工'以转移注意力。事后，他把你叫到办公室，语气复杂地让你'忘了这件事'，并给了你一笔奖金...",
    requiredEffects: [SpecialEffectType.ALIEN_TECHNOLOGY],
    priority: 7,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "最佳测试员",
    description: "你向同事展示外星装置，意外投射出老板摸鱼的图像，引起一片哗然。老板在一片混乱中急中生智，大声宣布这是公司新引进的'员工关怀影像系统'的一部分，并当场宣布你是'体验测试最佳员工'。虽然场面圆过去了，但你知道，老板看你的眼神里多了些别的东西...",
    requiredEffects: [SpecialEffectType.ALIEN_TECHNOLOGY],
    priority: 7,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "飞一般的感觉",
    description: "突然获得的飞行能力让你成为了公司的焦点。虽然大家都认为这是某种特技表演，但你成功利用这个能力抢救了一份即将被风吹走的重要合同。",
    requiredEffects: [SpecialEffectType.FLYING_ABILITY],
    priority: 6,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "老板的新宠",
    description: "不知为何，今天老板对你格外青睐。午餐时特意邀请你共进午餐，还在会议上多次称赞你的工作。同事们投来羡慕的目光...",
    requiredEffects: [SpecialEffectType.BOSS_FAVOR],
    priority: 4,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "老板的怒火",
    description: "你一到公司就感受到了老板的怒火。他显然因为某事对你不满，一整天都在找你的麻烦。这可能是你职业生涯的转折点...",
    requiredEffects: [SpecialEffectType.BOSS_ANGRY],
    priority: 4,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "物品损坏的代价",
    description: "你到达公司时发现今早弄坏的东西比想象中更麻烦。衣服上的污渍怎么都洗不掉，或者手机屏幕裂得更严重了。看来今天要破财了...",
    requiredEffects: [SpecialEffectType.ITEM_DAMAGE],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "折返之殇",
    description: "因为回家拿东西而耽误的时间让你整天都在赶进度。虽然最终还是到了公司，但那种忙乱的感觉一直持续到下班。下次一定要检查好再出门...",
    requiredEffects: [SpecialEffectType.RETURN_HOME],
    priority: 3,
    sentiment: EndingSentiment.NEUTRAL
  },
  {
    title: "好人好报",
    description: "今天帮助陌生人的善举似乎得到了回报。刚到公司就收到了一个意外的好消息，仿佛上天在奖励你的善良。心情格外舒畅！",
    requiredEffects: [SpecialEffectType.HELPED_STRANGER],
    priority: 4,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "社交电池耗尽",
    description: "上班路上的社交互动已经把你的精力消耗殆尽。一到公司你就想找个安静的角落躲起来，避免任何不必要的交流。今天注定是个安静的工作日...",
    requiredEffects: [SpecialEffectType.SOCIAL_BATTERY_DRAIN],
    priority: 2,
    sentiment: EndingSentiment.NEUTRAL
  },
  {
    title: "失而复得的惊魂",
    description: "虽然最终没有真的丢失重要物品，但那种惊慌失措的感觉让你一整天都心有余悸。每隔一会儿就要检查一下口袋，确认东西还在。这种被吓到的感觉真是太糟糕了...",
    requiredEffects: [SpecialEffectType.ITEM_LOST],
    priority: 3,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "多重打击",
    description: "今天简直是灾难日！物品损坏、心情糟糕、还感到绝望，这三重打击让你怀疑人生。坐在工位上时，你开始认真考虑是否应该重新规划自己的生活...",
    requiredEffects: [SpecialEffectType.ITEM_DAMAGE, SpecialEffectType.BAD_MOOD, SpecialEffectType.DESPAIR],
    priority: 6,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "正能量爆表",
    description: "帮助他人、心情愉快、自信提升，今天的你就像行走的正能量源泉！整个办公室的氛围都因为你的到来而变得更加积极向上。老板都忍不住多看了你几眼...",
    requiredEffects: [SpecialEffectType.HELPED_STRANGER, SpecialEffectType.GREAT_MOOD, SpecialEffectType.CONFIDENCE_BOOST],
    priority: 6,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "筋疲力尽的上班族",
    description: "你拖着疲惫的身躯走进办公室，感觉每一步都像灌了铅一样沉重。同事们的声音听起来都很遥远，你只想趴在桌子上好好休息。今天注定是效率极低的一天...",
    requiredEffects: [SpecialEffectType.TIRED],
    priority: 3,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "绝望深渊",
    description: "今天的你被绝望情绪笼罩着到达公司。看着熟悉的办公室，你突然觉得一切都失去了意义。同事们的问候声音都显得遥远而空洞，仿佛你与世界隔着一层厚厚的玻璃...",
    requiredEffects: [SpecialEffectType.DESPAIR],
    priority: 4,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "自信满满的一天",
    description: "今天的你信心爆棚地走进办公室！上班路上的成功经历让你觉得自己无所不能。同事们都注意到了你闪闪发光的状态，纷纷询问发生了什么好事。连最难搞的项目都显得不在话下！",
    requiredEffects: [SpecialEffectType.CONFIDENCE_BOOST],
    priority: 4,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "心灵的解脱",
    description: "一进入办公室，你就长长地松了一口气。上班路上的波折最终化险为夷，那种如释重负的感觉让你格外珍惜当下的平静。今天的工作热情比往常高涨了不少！",
    requiredEffects: [SpecialEffectType.RELIEF],
    priority: 3,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "焦虑症患者的日常",
    description: "你坐在工位上，脑海里还在反复确认是否真的带了所有必需品。每隔几分钟就要摸摸口袋，检查包里的物品。同事们看你一直在翻包的样子都觉得很奇怪...",
    requiredEffects: [SpecialEffectType.FORGOT_SOMETHING_ANXIETY],
    priority: 3,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "手机依赖症发作",
    description: "到达公司后你才意识到忘记带手机了。整个上午你都心神不宁，总觉得错过了什么重要消息。同事们看你不停摸口袋的样子都觉得很好笑，但你真的快要焦虑到崩溃了...",
    requiredEffects: [SpecialEffectType.PHONE_FORGOTTEN],
    priority: 4,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "压力锅即将爆炸",
    description: "上班路上积累的压力让你到达公司时已经精神紧绷。坐在工位上仍然无法完全放松，总觉得有什么不好的事情要发生。你深呼吸试图平静下来，但效果甚微...",
    requiredEffects: [SpecialEffectType.STRESS_INCREASE],
    priority: 4,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "形象受损记",
    description: "你低头看着被刮花的鞋子，心情瞬间跌到谷底。这双鞋可是你最喜欢的！走进办公室时努力避免让别人看到，但还是有同事注意到了。今天的自信心大打折扣...",
    requiredEffects: [SpecialEffectType.SCUFFED_SHOES],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "洁癖者的噩梦",
    description: "你坐在工位上，双手仍然感觉不太干净。虽然已经洗过了，但那种不适感挥之不去。你不停地看着自己的手，同事们都开始怀疑你是不是有什么强迫症...",
    requiredEffects: [SpecialEffectType.DIRTY_HANDS],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "神秘污渍事件",
    description: "你到达公司后才发现衣服上那个神秘的污渍比想象中更显眼。同事们都在猜测那到底是什么，而你只能尴尬地用文件夹挡着。今天绝对不能参加任何重要会议了...",
    requiredEffects: [SpecialEffectType.UNKNOWN_STAIN],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "人生重大失误",
    description: "上班路上的重大失误让你一整天都心情沉重。坐在工位上时脑海里还在回放那个尴尬的瞬间，仿佛全世界都看到了你的丑态。工作效率大打折扣，希望明天能好一些...",
    requiredEffects: [SpecialEffectType.MAJOR_FUMBLE],
    priority: 4,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "喘不过气的狼狈",
    description: "你气喘吁吁地冲进办公室，心跳还在狂跳不止。同事们都被你突然闯入的样子吓了一跳。你需要好一会儿才能平复呼吸，接下来的工作也受到了影响...",
    requiredEffects: [SpecialEffectType.OUT_OF_BREATH],
    priority: 2,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "超级赛亚人模式",
    description: "今天的你精力爆棚！刚到公司就感觉浑身充满了无穷的能量，仿佛可以一口气完成一周的工作量。同事们都惊讶于你的活力四射，纷纷询问你的秘诀...",
    requiredEffects: [SpecialEffectType.SUPER_ENERGY],
    priority: 4,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "负重前行者",
    description: "你带着各种额外的物品到达公司，感觉像个移动的杂货铺。虽然有些不便，但这些东西可能在关键时刻派上用场。同事们都好奇你今天怎么带了这么多东西...",
    requiredEffects: [SpecialEffectType.SLIGHTLY_ENCUMBERED],
    priority: 2,
    sentiment: EndingSentiment.NEUTRAL
  },
  {
    title: "迟到的代价",
    description: "你终于到达了公司，但已经迟到了。前台小姐用复杂的眼神看着你，而你只能低着头快速走向电梯。今天可能要找个借口向老板解释，希望不会影响绩效考核...",
    requiredEffects: [SpecialEffectType.LATE_FOR_WORK],
    priority: 5,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "情绪过山车",
    description: "上班路上的经历让你的情绪跌宕起伏，现在坐在工位上还没完全平静下来。一会儿开心一会儿沮丧，同事们都觉得你今天的状态有点奇怪。需要时间来调整心情...",
    requiredEffects: [SpecialEffectType.MOOD_CHANGE],
    priority: 3,
    sentiment: EndingSentiment.NEUTRAL
  },
  {
    title: "身心俱疲",
    description: "压力和疲惫的双重打击让你几乎无法正常工作。坐在工位上感觉身体和心理都到了极限，同事们都能看出你状态很糟糕。今天可能需要早点下班休息了...",
    requiredEffects: [SpecialEffectType.STRESS_INCREASE, SpecialEffectType.TIRED],
    priority: 6,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "社交焦虑症",
    description: "社交能量耗尽加上内心的焦虑，让你完全不想与人交流。你躲在工位角落，生怕有人过来搭话。这种状态下，团队合作简直是噩梦...",
    requiredEffects: [SpecialEffectType.SOCIAL_BATTERY_DRAIN, SpecialEffectType.FORGOT_SOMETHING_ANXIETY],
    priority: 5,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "完美救赎",
    description: "释然的心情加上满满的自信，让你感觉今天就是你的主场！上班路上的波折反而成为了你成长的踏脚石。同事们都被你正能量满满的状态感染，工作氛围前所未有的好！",
    requiredEffects: [SpecialEffectType.RELIEF, SpecialEffectType.CONFIDENCE_BOOST],
    priority: 6,
    sentiment: EndingSentiment.POSITIVE
  },
  {
    title: "形象全面崩塌",
    description: "鞋子刮花、衣服有神秘污渍、手还是脏的...今天的你简直是形象灾难的集合体！走进办公室的瞬间，所有人的目光都聚焦在你身上。你只想找个地缝钻进去，这绝对是职业生涯的黑历史...",
    requiredEffects: [SpecialEffectType.SCUFFED_SHOES, SpecialEffectType.UNKNOWN_STAIN, SpecialEffectType.DIRTY_HANDS],
    priority: 8,
    sentiment: EndingSentiment.NEGATIVE
  },
  {
    title: "人生至暗时刻",
    description: "绝望、重大失误、巨大压力...今天的你承受着人生的至暗时刻。坐在工位上时，你开始认真思考是否应该重新规划自己的人生道路。同事们都能感受到你身上散发的负能量，整个办公室的氛围都变得压抑...",
    requiredEffects: [SpecialEffectType.DESPAIR, SpecialEffectType.MAJOR_FUMBLE, SpecialEffectType.STRESS_INCREASE],
    priority: 9,
    sentiment: EndingSentiment.NEGATIVE
  }
];

/**
 * 状态管理器实现
 */
export class GameStateManager implements StateManager {
  private state: GameState;
  private config: GameConfig;

  /**
   * 构造函数
   * @param config 游戏配置
   */
  constructor(config: GameConfig) {
    this.config = config;
    this.state = this.createInitialState();
  }

  /**
   * 创建初始状态
   * @returns 初始游戏状态
   */
  private createInitialState(): GameState {
    return {
      status: GameStatus.NOT_STARTED,
      currentTime: this.config.startTime,
      distanceToWork: this.config.totalDistance,
      totalDistance: this.config.totalDistance,
      eventsEncountered: new Set<string>(),
      currentEvent: undefined,
      specialEffects: [],
      delayedEvents: []
    };
  }

  /**
   * 获取当前状态
   * @returns 当前游戏状态
   */
  getState(): GameState {
    return { ...this.state };
  }

  /**
   * 更新时间
   * @param minutes 时间变化（分钟）
   */
  updateTime(minutes: number): void {
    const validMinutes = Number(minutes);
    if (validMinutes !== null && typeof validMinutes === 'number' && !isNaN(validMinutes)) {
      this.state.currentTime += validMinutes;
    } else {
      if (this.state.currentTime === null || isNaN(this.state.currentTime)) {
        this.state.currentTime = 0;
      }
    }
    
    this.state.status = this.checkGameOver();
  }

  /**
   * 更新距离
   * @param km 距离改变（公里）
   */
  updateDistance(km: number): void {
    const distanceBeforeUpdate = this.state.distanceToWork;
    const validKm = Number(km);

    if (validKm !== null && typeof validKm === 'number' && !isNaN(validKm)) {
      const currentDistance = (typeof distanceBeforeUpdate === 'number' && !isNaN(distanceBeforeUpdate)) ? distanceBeforeUpdate : 0;
      this.state.distanceToWork = Math.max(0, currentDistance + validKm);
      
      if (isNaN(this.state.distanceToWork)) {
        this.state.distanceToWork = (typeof distanceBeforeUpdate === 'number' && !isNaN(distanceBeforeUpdate)) ? distanceBeforeUpdate : (this.config.totalDistance ?? 0);
      }
    } else {
      if (this.state.distanceToWork === null || isNaN(this.state.distanceToWork)) {
        this.state.distanceToWork = this.config.totalDistance ?? 0;
      }
    }
    
    this.state.status = this.checkGameOver();
  }

  /**
   * 直接设置距离
   * @param newDistance 新的距离值（公里）
   */
  setDistance(newDistance: number): void {
    this.state.distanceToWork = Math.max(0, newDistance);
  }

  /**
   * 设置当前事件
   * @param event 当前事件
   */
  setCurrentEvent(event: Event | null): void {
    this.state.currentEvent = event || undefined;
  }

  /**
   * 添加已遇到事件 (新实现，使用 Set)
   * @param eventId 事件ID
   */
  addSeenEvent(eventId: string): void {
    this.state.eventsEncountered.add(eventId);
  }

  /**
   * 获取所有已遇到事件的集合 (新实现)
   * @returns 已遇到事件的 Set<string>
   */
  getSeenEvents(): Set<string> {
    return this.state.eventsEncountered;
  }

  /**
   * 添加特殊效果
   * @param effect 特殊效果
   */
  addSpecialEffect(effect: SpecialEffect): void {
    const originalDistance = this.state.distanceToWork;
    let numericEffectType: SpecialEffectType | undefined;

    const effectTypeInput: string | SpecialEffectType = effect.type;

    if (typeof effectTypeInput === 'string') {
      const stringEffectType: string = effectTypeInput;
      const enumKey = stringEffectType.toUpperCase().replace(/\s+/g, '_') as keyof typeof SpecialEffectType;
      if (SpecialEffectType[enumKey] !== undefined && typeof SpecialEffectType[enumKey] === 'number') {
        numericEffectType = SpecialEffectType[enumKey] as SpecialEffectType;
      }
    } else if (typeof effectTypeInput === 'number' && SpecialEffectType[effectTypeInput] !== undefined) {
      numericEffectType = effectTypeInput;
    }

    if (numericEffectType !== undefined) {
      if (!this.state.specialEffects.some(e => e.type === numericEffectType)) {
        this.state.specialEffects.push({ type: numericEffectType, description: effect.description });
      }
    }

    if (this.state.distanceToWork !== originalDistance) {
      this.state.distanceToWork = originalDistance;
    }
    
    if (this.state.distanceToWork === null || isNaN(this.state.distanceToWork)) {
      this.state.distanceToWork = (typeof originalDistance === 'number' && !isNaN(originalDistance)) ? originalDistance : (this.config.totalDistance ?? 0);
      if (this.state.distanceToWork === null || isNaN(this.state.distanceToWork)) {
        this.state.distanceToWork = this.config.totalDistance ?? 0;
      }
    }
  }

  /**
   * 添加延迟触发的事件
   * @param event 延迟事件
   */
  addDelayedEvent(event: DelayedEvent): void {
    if (!this.state.delayedEvents) {
      this.state.delayedEvents = [];
    }
    
    // 添加到延迟事件列表
    this.state.delayedEvents.push(event);
  }

  /**
   * 获取下一个应该触发的延迟事件
   * @returns 下一个应该触发的延迟事件，如果没有则返回null
   */
  getNextDelayedEvent(): DelayedEvent | null {
    if (!this.state.delayedEvents || this.state.delayedEvents.length === 0) {
      return null;
    }
    
    // 查找延迟计数为0的事件
    const readyEvent = this.state.delayedEvents.find(event => 
      event.delay <= 0 && 
      (!event.conditions || this.checkEventConditions(event.conditions))
    );
    
    if (readyEvent) {
      // 从列表中移除该事件
      this.state.delayedEvents = this.state.delayedEvents.filter(e => e !== readyEvent);
      return readyEvent;
    }
    
    return null;
  }

  /**
   * 更新延迟事件的计数
   */
  updateDelayedEvents(): void {
    if (!this.state.delayedEvents || this.state.delayedEvents.length === 0) {
      return;
    }
    
    // 将所有延迟事件的延迟计数减1
    this.state.delayedEvents = this.state.delayedEvents.map(event => ({
      ...event,
      delay: event.delay - 1
    }));
  }

  /**
   * 检查事件条件是否满足
   * @param conditions 条件列表
   * @returns 是否满足所有条件
   */
  checkEventConditions(conditions: EventCondition[]): boolean {
    if (!conditions || conditions.length === 0) {
      return true;
    }
    
    // 检查每个条件
    return conditions.every(condition => {
      switch (condition.type) {
        case ConditionType.TIME:
          return this.checkTimeCondition(condition);
        case ConditionType.DISTANCE:
          return this.checkDistanceCondition(condition);
        case ConditionType.SPECIAL_EFFECT:
          return this.checkSpecialEffectCondition(condition);
        case ConditionType.EVENT_COUNT:
          return this.checkEventCountCondition(condition);
        default:
          return false;
      }
    });
  }

  /**
   * 检查时间条件
   * @param condition 条件
   * @returns 是否满足条件
   */
  private checkTimeCondition(condition: EventCondition): boolean {
    const currentTime = this.state.currentTime;
    const targetTime = Number(condition.parameter);
    
    switch (condition.comparison) {
      case 'eq': return currentTime === targetTime;
      case 'gt': return currentTime > targetTime;
      case 'lt': return currentTime < targetTime;
      case 'gte': return currentTime >= targetTime;
      case 'lte': return currentTime <= targetTime;
      default: return false;
    }
  }

  /**
   * 检查距离条件
   * @param condition 条件
   * @returns 是否满足条件
   */
  private checkDistanceCondition(condition: EventCondition): boolean {
    const currentDistance = this.state.distanceToWork;
    const targetDistance = Number(condition.parameter);
    
    switch (condition.comparison) {
      case 'eq': return currentDistance === targetDistance;
      case 'gt': return currentDistance > targetDistance;
      case 'lt': return currentDistance < targetDistance;
      case 'gte': return currentDistance >= targetDistance;
      case 'lte': return currentDistance <= targetDistance;
      default: return false;
    }
  }

  /**
   * 检查特殊效果条件
   * @param condition 条件
   * @returns 是否满足条件
   */
  private checkSpecialEffectCondition(condition: EventCondition): boolean {
    // 检查是否存在指定的特殊效果
    const effectType = Number(condition.parameter);
    return this.state.specialEffects.some(effect => effect.type === effectType);
  }

  /**
   * 检查事件数量条件
   * @param condition 条件
   * @returns 是否满足条件
   */
  private checkEventCountCondition(condition: EventCondition): boolean {
    const eventCount = this.state.eventsEncountered.size;
    const targetCount = Number(condition.parameter);
    
    switch (condition.comparison) {
      case 'eq': return eventCount === targetCount;
      case 'gt': return eventCount > targetCount;
      case 'lt': return eventCount < targetCount;
      case 'gte': return eventCount >= targetCount;
      case 'lte': return eventCount <= targetCount;
      default: return false;
    }
  }

  /**
   * 检查游戏是否结束
   * @returns 游戏状态
   */
  checkGameOver(): GameStatus {
    // 如果已到达公司（距离为0）
    if (this.state.distanceToWork <= 0) {
      // 确保距离不为负数
      this.state.distanceToWork = 0;
      return GameStatus.GAME_OVER;
    }
    
    // 如果太晚了（例如超过上班时间2小时）
    if (this.state.currentTime > this.config.workStartTime + 120) {
      return GameStatus.GAME_OVER;
    }
    
    return GameStatus.RUNNING;
  }

  /**
   * 获取游戏的结局类型。
   * 只有在游戏结束后才能确定结局。
   * 首先检查是否满足特殊结局的条件，如果满足则返回特殊结局。
   * 否则，根据到达时间判断结局类型。
   * @returns 游戏的结局类型。
   */
  public getEndingType(): EndingType {
    // 游戏未结束无法判断结局
    if (this.state.status !== GameStatus.GAME_OVER) {
      return EndingType.NEVER; // 或者可以抛出错误或返回特定状态
    }

    // 检查特殊结局
    const specialEnding = this.getSpecialEnding();
    if (specialEnding) {
      // 如果存在特殊结局，直接返回表示特殊的结局类型
      return EndingType.SPECIAL;
    }

    // 如果未到达（例如超时），则结局为NEVER
    if (this.state.distanceToWork > 0) {
      return EndingType.NEVER;
    }

    // 否则，根据到达时间计算普通结局
    const arrivalTime = this.state.currentTime; // 到达时间就是游戏结束时的时间
    const targetTime = this.config.workStartTime; // 目标时间是配置的上班时间
    const timeDiff = arrivalTime - targetTime; // 单位是分钟

    if (timeDiff < 0) { // 严格小于0才算早到
      return EndingType.EARLY;
    } else if (timeDiff === 0) { // 只有准时到达才算准时
      return EndingType.ON_TIME;
    } else if (timeDiff <= 30) { // 1到30分钟算迟到
      return EndingType.LATE;
    } else { // 超过30分钟算严重迟到
      return EndingType.VERY_LATE;
    }
  }

  /**
   * 获取特殊结局。
   * 只有在游戏结束后才可能触发特殊结局。
   * 检查当前状态是否满足某个预定义特殊结局的所有 requiredEffects。
   * 根据到达时间状态过滤结局类型：迟到时只能触发坏结局和中性结局。
   * @returns 如果满足特殊结局条件，则返回 SpecialEnding 对象，否则返回 null。
   */
  public getSpecialEnding(): SpecialEnding | null {
    if (this.state.status !== GameStatus.GAME_OVER) {
      return null; // 游戏未结束，不可能有特殊结局
    }

    // 计算时间状态
    const arrivalTime = this.state.currentTime;
    const targetTime = this.config.workStartTime;
    const timeDiff = arrivalTime - targetTime;
    const isLate = timeDiff > 0; // 迟到：任何晚于目标时间的情况

    // 获取当前玩家拥有的特殊效果类型列表
    const currentEffectTypes = this.state.specialEffects.map(effect => effect.type);

    // 创建一个列表来存储所有满足条件的结局
    const satisfiedEndings: SpecialEnding[] = [];

    // 遍历所有 SPECIAL_ENDINGS
    for (const ending of SPECIAL_ENDINGS) {
      // 检查是否满足所有必需的特殊效果
      const conditionsMet = ending.requiredEffects.every(requiredType =>
        currentEffectTypes.includes(requiredType)
      );

      if (conditionsMet) {
        // 根据时间状态过滤结局
        if (isLate) {
          // 迟到时只能触发坏结局和中性结局
          if (ending.sentiment === EndingSentiment.NEGATIVE || ending.sentiment === EndingSentiment.NEUTRAL) {
            satisfiedEndings.push(ending);
          }
        } else {
          // 提前/准时到达时可以触发所有类型的结局
          satisfiedEndings.push(ending);
        }
      }
    }

    // 如果有满足条件的结局，从中随机选择一个
    if (satisfiedEndings.length > 0) {
      const randomIndex = Math.floor(Math.random() * satisfiedEndings.length);
      return satisfiedEndings[randomIndex];
    }

    return null; // 没有找到满足条件的特殊结局
  }

  /**
   * 重置游戏
   */
  resetGame(): void {
    this.state = this.createInitialState();
  }

  /**
   * 开始游戏
   */
  startGame(): void {
    this.state.status = GameStatus.RUNNING;
    // It's good practice to also reset other relevant state parts here if needed,
    // e.g., eventsEncountered, specialEffects, if resetGame isn't called immediately before.
    // For now, assuming resetGame handles full reset.
  }

  /**
   * 获取当前游戏状态 (status)
   * @returns 当前游戏状态
   */
  getGameStatus(): GameStatus {
    return this.state.status;
  }
} 